import { AuthStatusOptionModel } from "../../../../../data-model/authStatusOptions";
import { FirestoreDocumentReference } from "../../../../../../shared/api/firebase/references";
import { ModalId } from "../../../../../../shared/enums/modalId";
import { useOptionsConfig } from "./useOptionsConfig";

export const useAuthOptions = (selectedOrgId: string) => {
  return useOptionsConfig<AuthStatusOptionModel>({
    selectedOrgId,
    fetchDocumentRef: FirestoreDocumentReference.authStatusOptions,
    documentKey: "auth_options",
    modalId: ModalId.AUTH_OPTIONS_MODAL,
    deleteModalId: ModalId.AUTH_OPTIONS_DELETE_MODAL,
    getUniqueKey: (item) => item.id,
    sortFields: ["priority", "left_pane_display_order"],
    reorderModalId: ModalId.OPTIONS_REORDER_MODAL,
  });
};
